module.exports = __webpack_public_path__ + "img/balancea-axe.ca0328d8.svg";